import React from 'react';

const InfoPage = () => {
const QnA = {
  
  'What’s our mission?': "To be the virtual home for all Pokémon collectors — whether you're just getting started or already deep in the hobby, looking for a specific card or just having fun window shopping. A space made by real collectors, for real collectors, with variety, fun, and convenience at its core.",
  
  'Can I sell my cards?': "Absolutely. You can choose to consign your cards (you get paid when they sell), or opt for an upfront buyout if you want quick payment. We'll take care of listing, storage, shipping, and support. Email us at avgpokecollector@gmail.com",
  
  'Refund/Returns policy': 'Due to the nature of our business, all sales are final. We do not offer refunds or accept returns for change of mind, mistaken purchases, or buyer’s remorse. While we take our best care in packaging, you are entitled to a replacement or refund if the item you receive is: faulty or damaged, significantly different from its description, or unfit for its intended purpose. If you believe you have received a faulty or incorrect item, please contact us within 48 hours of receiving your order with details and supporting evidence (e.g., photos). We reserve the right to assess the issue and determine whether a remedy under consumer law applies. Thank you for your understanding and support.',

  "Grading": "If you choose to submit a card for grading through us, we send off every month with our local shop. Any additional costs may be required and will be communicated",
  
  "Abandoned Submissions": "Once graded submissions are returned, we will make reasonable efforts to contact you for payment and collection. If payment is not received within 30 days of attempted contact, the submitted item will be deemed abandoned, and ownership of the item will be forfeited.",

  "Staff Conduct & Safety Policy": "We are committed to providing a safe working environment for our employees. Harassment, abuse, intimidation, or threats toward staff members are strictly prohibited and will not be tolerated under any circumstances. Violations of this policy may result in immediate termination of service, permanent bans, and further action as deemed appropriate, including referral to law enforcement."

  };

  return (
    <div className='qna hide-scrollbar'>
      {Object.entries(QnA).map(([question, answer], index) => (
        <div key={index} className='bottom-margin'>
          <h1 className='question no-margin'>{question}</h1>
          <div className='answer no-margin'>{answer}</div>
        </div>
      ))}
    </div>
  );
};

export default InfoPage;
